module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAFtCAMAAAANn9vkAAAAM1BMVEUAAAAxMTGDg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4NMd4wpAAAAEHRSTlMAY0Tud2bdM1URu5kiiKrMR7NsxgAAAQJJREFUSMftlttuhDAMRKe2yR3W//+1jeso3aV9pBLQHQnlCNkMjjEKTB/9esO/gWuqbQNIv4HVhUgm0X1MZByl4cXmJUoUp9FPmDEz6/jXUDELUSiZKb1CZAPJ6MqC0+p5V1W8g17IC2wb1YdB3rTEA3yJYBLu3mLrAiydQl87BbP2bs47wglILDPLn3PVnj7vPFXlFchLYMlWnxeNorV5dI+o5NiqlrQfPYo4v3YjLDpaTK/QNoOheLdv7LdBawOWEArVAOY1C4eIlHEJ5eJr4i9ohcVLDtn/xguXNkKrClzEM/8mXcbK3uX1kXwqu5VLaUBIA2bMzLqzTnL6esOfwyctJxACZvGQwwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/about_right_icon01.png
// module id = Hmsc
// module chunks = 1